import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import Logo from "../images/Logo.svg";
import { useLocation, Link, useSearchParams } from "react-router-dom";
import Loader from "./Loader";
import { TailSpin } from "react-loader-spinner";
import NavBar from "./Navbar";
import TopNavBar from "./TopNavbar";
import "../styles/InvoiceDetail.css";
import { useAuth } from "../auth/auth";
import { PERMISSIONS } from "../utils/rbac";
import {
  deniedActionClass,
  usePermissionGuard,
} from "../hooks/usePermissionGuard";
import html2pdf from "html2pdf.js";
import generatePdfIcon from "../images/generatePdfIcon.svg";
import generateCsvIcon from "../images/generateCsvIcon.svg";
const apiUrl = process.env.REACT_APP_API_URL;

const MultipleInvoiceDetail = () => {
  const location = useLocation();
  //   console.log(location.state);

  const [invoices, setInvoices] = useState([]);
  const [searchParams] = useSearchParams();
  // const invoiceIds = location.state;
  const [invoiceIds, setInvoiceIds] = useState([]);
  const invoiceId = 162;
  const [invoice, setInvoice] = useState(null);
  const [showOptions, setShowOptions] = useState(false);
  const [rateString, setUniqueRatesString] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [totalAdditions, setTotalAdditions] = useState(0);
  const [totalDeductions, setTotalDeductions] = useState(0);
  const [totalAmount, setTotalAmount] = useState(0);
  const [subTotal, setSubTotal] = useState(0);
  const [totalAdditionsList, setTotalAdditionsList] = useState([]);
  const [totalDeductionsList, setTotalDeductionsList] = useState([]);
  const [totalAmountList, setTotalAmountList] = useState([]);
  const [subTotalList, setSubTotalList] = useState([]);

  useAuth();
  const { guardAction, PermissionDialog, isAllowed } = usePermissionGuard();
  const canGeneratePdf = isAllowed(PERMISSIONS.GENERATE_PDF);

  function formatInvoiceAdditions(additions) {
    const numericValue = Number(additions);

    if (isNaN(numericValue) || numericValue % 1 !== 0) {
      // Check if it's a decimal
      const formattedValue = numericValue.toFixed(2); // Ensure 2 digits after the decimal point
      return formattedValue;
    } else {
      // If it's an integer, add .00 to make it a decimal with 2 digits after the decimal point
      return additions + ".00";
    }
  }

  const calculateSummary = (formDataList) => {
    let totalAdditions = 0;
    let totalDeductions = 0;
    let totalAmount = 0;
    let subTotal = 0;

    formDataList.forEach((formData) => {
      totalAdditions += parseFloat(formData.Additions || 0);
      totalDeductions += parseFloat(formData.Deductions || 0);
      totalAmount += parseFloat(calculateAmount(formData));
      subTotal += parseFloat(calculateSubTotal(formData));
    });

    return { totalAdditions, totalDeductions, totalAmount, subTotal };
  };

  function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }
  function formatValue(value) {
    return value === "0.00" ? "-" : value;
  }
  const roundTwo = (num) =>
    Math.round((parseFloat(num || 0) + Number.EPSILON) * 100) / 100;

  const calculateSubTotal = (formData) => {
    let amount = 0;

    if (formData.paymentType === "salary") {
      amount = roundTwo(formData.salary || 0);
    } else if (
      formData.paymentType === "hourly" ||
      formData.paymentType === "overtime"
    ) {
      const hours = parseFloat(formData.hours || 0);
      const minutes = parseFloat(formData.minutes || 0);

      let hoursWorked = hours + minutes / 60;

      hoursWorked = roundTwo(hoursWorked);
      const rate = parseFloat(formData.hourlyRate || 0);
      if (formData.paymentType === "overtime") {
        amount = roundTwo(hoursWorked * 1.5 * rate);
      } else {
        amount = roundTwo(hoursWorked * rate);
      }
    }
    return amount;
  };

  const calculateAmount = (formData) => {
    let amount = 0;

    if (formData.paymentType === "salary") {
      amount = roundTwo(formData.salary || 0);
    } else if (
      formData.paymentType === "hourly" ||
      formData.paymentType === "overtime"
    ) {
      let hours = parseFloat(formData.hours || 0);
      let minutes = parseFloat(formData.minutes || 0);

      let hoursWorked = roundTwo(hours + minutes / 60);

      const rate = parseFloat(formData.hourlyRate || 0);
      if (formData.paymentType === "overtime") {
        amount = roundTwo(hoursWorked * 1.5 * rate);
      } else {
        amount = roundTwo(hoursWorked * rate);
      }
    }
    // Adjust amount for additions and deductions
    const additions = roundTwo(formData.Additions || 0);
    const deductions = roundTwo(formData.Deductions || 0);

    amount = roundTwo(amount + additions - deductions);
    return amount;
  };

  const handleDownloadOption = (option) => {
    setShowOptions(false);

    if (option === "pdf") {
      handleGeneratePDF(); // Call your PDF generation function
    } else if (option === "csv") {
      generateCSV(invoice); // Call your CSV generation function
    }
  };

  function generateCSV(invoice) {
    const csvContent = [];

    // Add headers to the CSV
    csvContent.push(
      "S.no,Employee Id,Invoice Id,Name,Email,Pay Rate($),Hours,Additions,Deductions,Amount,YTD Amount,Issue-Date,Pay-Period,From"
    );

    // Add data rows to the CSV
    const rowData = [
      1, // S.no
      invoice.userId,
      invoice.id,
      invoice.name,
      invoice.email,
      invoice.payRate,
      `${invoice.hours}.${invoice.minutes}hr`,
      invoice.Additions,
      invoice.Deductions,
      invoice.Amount,
      invoice.YTDFinal || invoice.YTDAmount,
      `"${invoice.formattedTimestamp}"`, //issue date,
      `"${invoice.payPeriod}"`,
      "Surplus staff driver",
    ];
    csvContent.push(rowData.join(","));

    // Join rows with newline character
    const csvString = csvContent.join("\n");

    // Create a Blob containing the CSV data
    const blob = new Blob([csvString], { type: "text/csv" });

    // Create a link to download the CSV file
    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);
    link.download = "payslip-detail.csv";

    // Trigger a click on the link to initiate the download
    link.click();
  }

  const containerRef = useRef();

  const [pdfLoader, setPdfLoader] = useState(false);

  const chooseHandleGeneratePDF = () => {
    guardAction(PERMISSIONS.GENERATE_PDF, "generate PDF", () => {
      const searchParamsValue = new URLSearchParams(window.location.search);
      const isAll = searchParamsValue.get("generate") === "all";
      const generateType = searchParamsValue.get("generate");
      const rangeId = searchParamsValue.get("range_id");

      if (isAll) {
        handleGeneratePDFNew("all", "");
      } else if (generateType === "archived" && rangeId) {
        handleGeneratePDFNew("archived", rangeId);
      } else {
        const idsParam = Array.isArray(location.state)
          ? location.state.join(",")
          : "";
        handleGeneratePDFNew("custom", idsParam);
      }
    });
  };

  const handleGeneratePDF = () => {
    setPdfLoader(true);

    const container = document.querySelector(".slips_container");
    const contentToPrint = container.cloneNode(true);

    const style = document.createElement("style");
    style.textContent = `

  .slips_container {
    background-color: #EDF6F0;
    width: 100%;
    min-height: 100%;
    box-sizing: border-box;
  }

  .invoice-centre-div {
    break-inside: avoid;
    page-break-inside: avoid;
    background-color: #EDF6F0;
    padding: 15px 0;
    width: 80%; 
  }

  .invoice-centre-div:first-child {
    margin-top: 0;
  }

  .invoice-centre-div:last-child {
    margin-bottom: 0;
  }
  .row-white-complete tr {
    border-bottom: 0px solid #EDF6F0;
    min-height: 31px;
  }
  .row-white-complete td{
    padding: 8px 8px 1px;
  }
`;
    contentToPrint.prepend(style);
    contentToPrint.style.backgroundColor = "#EDF6F0";
    // ✅ html2pdf returns a promise
    html2pdf()
      .from(contentToPrint)
      .set({
        filename: "payslip-detail.pdf",
        image: { type: "jpeg", quality: 0.98 },
        html2canvas: { 
          scale: 3,
          windowWidth: 1200
        },
        jsPDF: { unit: "mm", format: "a4", orientation: "portrait" },
      })
      .outputPdf("blob")
      .then((blob) => {
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = "payslip-detail.pdf";
        link.click();
      })
      .finally(() => {
        setPdfLoader(false); // ✅ Always turn off loader here
      });
  };

  const handleGeneratePDFNew = async (type, ids) => {
    setPdfLoader(true);

    try {
      let response = "";
      if (type == "all") {
        response = await axios.get(`${apiUrl}/download-payslips?type=all`, {
          responseType: "blob", // 👈 Important for binary files
        });
      } else if (type == "archived") {
        response = await axios.get(
          `${apiUrl}/download-payslips?type=archived&rangeId=${ids}`,
          {
            responseType: "blob", // 👈 Important for binary files
          }
        );
      } else {
        response = await axios.get(
          `${apiUrl}/download-payslips?type=custom&ids=${ids}`,
          {
            responseType: "blob", // 👈 Important for binary files
          }
        );
      }
      // Create a blob from the response and download it
      const blob = new Blob([response.data], { type: "application/pdf" });
      const url = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.download = "Payslips.pdf"; // Set your preferred filename
      document.body.appendChild(link);
      link.click();

      // Cleanup
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Failed to download payslips:", error);
      alert("Download failed. Please try again.");
    } finally {
      setPdfLoader(false);
    }
  };

  function getAddressProperties(formDataList) {
    let parsedList = JSON.parse(formDataList);
    let addressPropertiesSet = new Set(parsedList.map((item) => item.property));
    if (addressPropertiesSet.size === 1) {
      return [...addressPropertiesSet][0];
    } else {
      return [...addressPropertiesSet].join(",");
    }
  }

  // useEffect(() => {
  //   const fetchInvoiceDetails = async () => {
  //     try {
  //       setIsLoading(true);
  //       const fetchedInvoices = await Promise.all(
  //         invoiceIds.map(async (id) => {
  //           const response = await axios.post(`${apiUrl}/getInvoiceDetail`, {
  //             id: id,
  //           });

  //           const parsedFormDataList = JSON.parse(
  //             response.data.data.formDataList
  //           );
  //           const summary = calculateSummary(parsedFormDataList);
  //           return {
  //             invoiceData: response.data.data,
  //             summary: summary,
  //           };
  //         })
  //       );
  //       const totalAdditionsList = fetchedInvoices.map(
  //         (item) => item.summary.totalAdditions
  //       );
  //       const totalDeductionsList = fetchedInvoices.map(
  //         (item) => item.summary.totalDeductions
  //       );
  //       const totalAmountList = fetchedInvoices.map(
  //         (item) => item.summary.totalAmount
  //       );
  //       const subTotalList = fetchedInvoices.map(
  //         (item) => item.summary.subTotal
  //       );

  //       setTotalAdditionsList(totalAdditionsList);
  //       setTotalDeductionsList(totalDeductionsList);
  //       setTotalAmountList(totalAmountList);
  //       setSubTotalList(subTotalList);

  //       setInvoices(fetchedInvoices.map((item) => item.invoiceData));
  //     } catch (error) {
  //     } finally {
  //       setIsLoading(false);
  //     }
  //   };

  //   fetchInvoiceDetails();
  // }, [invoiceId, invoiceIds]);

  const fetchAllInvoiceIds = async () => {
    const response = await axios.get(`${apiUrl}/getAllInvoiceIds`);
    return response.data.invoiceIds; // Assuming backend returns { invoiceIds: [...] }
  };

  const fetchAllArchivedInvoiceIds = async (rangeId) => {
    const response = await axios.get(
      `${apiUrl}/getAllArchivedInvoiceIds?rangeId=${rangeId}`
    );
    return response.data.invoiceIds; // Assuming backend returns { invoiceIds: [...] }
  };
  useEffect(() => {
    const abortController = new AbortController();

    const init = async () => {
      setIsLoading(true);

      try {
        let ids = [];

        if (searchParams.get("generate") === "all") {
          const response = await axios.get(`${apiUrl}/getAllInvoiceIds`, {
            signal: abortController.signal,
          });
          ids = response.data.invoiceIds;
        } else if (
          searchParams.get("generate") === "archived" &&
          searchParams.get("range_id") != ""
        ) {
          const range = searchParams.get("range_id");
          const response = await axios.get(
            `${apiUrl}/getAllArchivedInvoiceIds?rangeId=${range}`,
            {
              signal: abortController.signal,
            }
          );
          ids = response.data.invoiceIds;
        } else {
          ids = location.state || [];
        }

        if (abortController.signal.aborted) return;

        setInvoiceIds(ids);

        const batchSize = 8;
        const fetchedInvoices = [];

        for (let i = 0; i < ids.length; i += batchSize) {
          if (abortController.signal.aborted) return;

          const batch = ids.slice(i, i + batchSize);
          const batchInvoices = await Promise.all(
            batch.map(async (id) => {
              const response = await axios.post(
                `${apiUrl}/getInvoiceDetail`,
                {
                  id: id,
                },
                {
                  signal: abortController.signal,
                }
              );

              const parsedFormDataList = JSON.parse(
                response.data.data.formDataList
              );
              const summary = calculateSummary(parsedFormDataList);

              const uniqueRates = [
                ...new Set(
                  parsedFormDataList
                    .map((item) => item.hourlyRate)
                    .filter((rate) => rate !== undefined && rate !== null)
                ),
              ];

              const formattedRatesString = uniqueRates
                .map((rate) => `$${formatInvoiceAdditions(rate)}`)
                .join(", ");

              const payRateString =
                formattedRatesString ||
                `$${response.data.data.payRate.toString()}`;

              return {
                invoiceData: {
                  ...response.data.data,
                  payRateString,
                },
                summary: summary,
              };
            })
          );

          fetchedInvoices.push(...batchInvoices);
        }

        if (abortController.signal.aborted) return;

        setTotalAdditionsList(
          fetchedInvoices.map((item) => item.summary.totalAdditions)
        );
        setTotalDeductionsList(
          fetchedInvoices.map((item) => item.summary.totalDeductions)
        );
        setTotalAmountList(
          fetchedInvoices.map((item) => item.summary.totalAmount)
        );
        setSubTotalList(fetchedInvoices.map((item) => item.summary.subTotal));
        setInvoices(fetchedInvoices.map((item) => item.invoiceData));
      } catch (error) {
        if (abortController.signal.aborted) return;
        console.error("Error fetching invoice detail:", error);
      } finally {
        if (abortController.signal.aborted) return;
        setIsLoading(false);
      }
    };

    init();

    return () => {
      abortController.abort();
    };
  }, [location.search, location.state]);

  return (
    <div className="feedback-parent-container">
      <PermissionDialog />
      <NavBar />
      <TopNavBar />
      <div className="invoice-detail-container">
        {pdfLoader && <Loader />}
        <div className="admin-header">
          <div className="left-section invoice-detail-left-section">
            <h1 className="admin-header-title hide-invoice-header-title">
              <Link
                to="/invoiceList"
                className="admin-card-title-link custom-link"
              >
                <span className="fade-text">Payslip List</span>
              </Link>
              {" > "}
              <span className="admin-card-title-span top-heading-invoice-Detail">
                Payslip Detail
              </span>
            </h1>
          </div>

          <div className="right-section">
            <div className="download-right-buttons employee-invoice-download-right-btns">
              <button
                className={`generate-pdf-btn employee-invoice-pdf-btn ${deniedActionClass(canGeneratePdf)}`}
                onClick={chooseHandleGeneratePDF}
              >
                <img
                  src={generatePdfIcon}
                  alt="Download"
                  className="downloadIcon"
                />
                Generate PDF
              </button>

              {/* <button
                className="generate-pdf-btn generate-csv-btn"
                onClick={() => generateCSV(invoice)}
              >
                <img
                  src={generateCsvIcon}
                  alt="Download"
                  className="downloadIcon"
                />
                Generate CSV
              </button> */}
            </div>
          </div>
        </div>
        {isLoading && (
          <div className="spinner-container">
            <TailSpin
              type="TailSpin"
              color="rgba(135, 106, 237, 1)"
              height={70}
              width={70}
              timeout={5000}
            />
          </div>
        )}
        <div
          className="slips_container"
          style={{
            paddingBottom: "50px",
          }}
        >
          {isLoading == false &&
            invoices.map((invoice, index) => (
              //    {invoices.map((invoice, index) => (
              <div
                className="invoice-centre-div"
                style={{
                  // height:'20rem',
                  marginTop: index > 0 ? "5px" : "0px",
                  borderBottom:
                    index === invoices.length - 1 ? "none" : "2px dotted",
                }}
                key={invoice.id}
                ref={containerRef}
              >
                <div className="invoice-header">
                  <div className="invoice-header-left">
                    <p className="invoice-heading-decoration">Payslip</p>
                  </div>
                  <div className="invoice-header-image-right">
                    <img src={Logo} alt="Logo" />
                  </div>
                </div>

                <div className="invoice-info">
                  <p className="margin-zero">{`#${invoice.id}`}</p>
                  <p className="margin-zero">
                    <span className="issue-date-label">Issue Date - </span>
                    {invoice.formattedTimestamp}
                  </p>
                </div>

                <div className="green-separator"></div>
                <div className="invoice-middle-header">
                  <p className="invoice-bold-text">From</p>
                  <p className="invoice-bold-text">To</p>
                </div>
                <div className="invoice-middle-header">
                  <p className="invoice-detail-p-text">{`Surplus Pc Inc`}</p>
                  <p className="invoice-detail-p-text">{`${invoice.name}`}</p>
                </div>

                <div className="invoice-middle-header">
                  <p className="pay-period">Pay Period</p>
                  {/* {invoice.email && ( */}
                  <p className="invoice-detail-p-text">{invoice.email}</p>
                  {/* )} */}
                </div>

                <div className="invoice-middle-header">
                  <p className="invoice-detail-p-text">{`${invoice.payPeriod}`}</p>
                  <p className="invoice-detail-p-text">{`Employee Id - #${invoice.userId}`}</p>
                </div>
                <div className="invoice-middle-header">
                  {invoice.payment_method ? (
                    <p className="pay-period">Payment Method</p>
                  ) : (
                    <p></p>
                  )}
                  <p className="invoice-detail-p-text">
                    {" "}
                    Pay Rate - {invoice.payRateString}
                  </p>
                </div>
                {invoice.payment_method && (
                  <>
                    <div className="invoice-middle-header">
                      <p
                        className={`invoice-detail-p-text payment_method ${
                          invoice.payment_method
                            ? invoice.payment_method
                                .toLowerCase()
                                .replace(/\s+/g, "-")
                            : "no-method"
                        }`}
                      >
                        {invoice.payment_method || "---"}
                      </p>
                    </div>
                  </>
                )}

                <div className="table-container">
                  <table className="invoice-table payslipgeneratedtable even-invoice-table invoice-detail-table-main row-white-complete">
                    <thead>
                      <tr>
                        <th>Property</th>
                        <th>Type</th>
                        <th>Value</th>
                        <th>Additions</th>
                        <th>Deductions</th>
                        <th>Total</th>
                      </tr>
                    </thead>
                    <tbody>
                      {JSON.parse(invoice.formDataList).map((data, index) => (
                        <tr key={index}>
                          <td>{data.property}</td>
                          <td>{capitalizeFirstLetter(data.paymentType)}</td>
                          <td>
                            {data.paymentType === "salary"
                              ? `$${formatInvoiceAdditions(data.salary || 0.0)}`
                              : `${data.hours}:${data.minutes
                                  .toString()
                                  .padStart(2, "0")} hrs`}
                          </td>
                          <td>
                            <div>
                              {formatValue(
                                formatInvoiceAdditions(data.Additions)
                              ) !== "-" && "$"}
                              {formatValue(
                                formatInvoiceAdditions(data.Additions)
                              )}
                            </div>
                            <div>
                              {data.additionsType !== ""
                                ? `(${data.additionsType})`
                                : ""}
                            </div>
                          </td>
                          <td>
                            <div>
                              {formatValue(
                                formatInvoiceAdditions(data.Deductions)
                              ) !== "-" && "$"}
                              {formatValue(
                                formatInvoiceAdditions(data.Deductions)
                              )}
                            </div>
                            <div>
                              {data.deductionsType !== ""
                                ? `(${data.deductionsType})`
                                : ""}
                            </div>
                          </td>
                          <td>
                            ${formatInvoiceAdditions(calculateAmount(data))}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>

                  <div className="table-summry-container">
                    <div className="table-right">
                      {/* <table className="amount-table invoice-table even-invoice-table row-white invoice-detail-table-main">
                    <thead>
                      <tr>
                        <th>Amount</th>
                        <th>YTD Amount</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>${formatInvoiceAdditions(invoice.Amount)}</td>
                        <td>${formatInvoiceAdditions(invoice.YTDAmount)}</td>
                      </tr>
                    </tbody>
                  </table> */}
                    </div>
                    <div
                      style={{
                        flexDirection: "row",
                        justifyContent: "space-between",
                      }}
                      className="summary-invoice-detail"
                    >
                      <div className="inner_detail_divs">
                        <span className="generate-invoice-user-detail-left-text">
                          Sub Total:
                        </span>
                        <span className="user-particular">
                          {" "}
                          ${formatInvoiceAdditions(subTotalList[index])}
                        </span>
                      </div>
                      <div className="inner_detail_divs">
                        <span className="generate-invoice-user-detail-left-text">
                          Additions:
                        </span>
                        <span className="user-particular">
                          {" "}
                          ${formatInvoiceAdditions(totalAdditionsList[index])}
                        </span>
                      </div>
                      <div className="inner_detail_divs">
                        <span className="generate-invoice-user-detail-left-text">
                          Deductions:
                        </span>
                        <span className="user-particular">
                          {" "}
                          ${formatInvoiceAdditions(totalDeductionsList[index])}
                        </span>
                      </div>
                      <div className="inner_detail_divs">
                        <span className="generate-invoice-user-detail-left-text">
                          Total:
                        </span>
                        <span className="user-particular total-amount-text">
                          {" "}
                          ${formatInvoiceAdditions(totalAmountList[index])}
                        </span>
                      </div>
                      <div className="inner_detail_divs_last">
                        <span className="generate-invoice-user-detail-left-text">
                          YTD Amount:
                        </span>
                        <span className="user-particular">
                          {" "}
                          $
                          {formatInvoiceAdditions(
                            invoice.YTDFinal || invoice.YTDAmount
                          )}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              //   ))}
            ))}
        </div>
      </div>
    </div>
  );
};

export default MultipleInvoiceDetail;
